import { BetType } from "./Enums";

export enum BetState{
    open,
    live,
    close
}

export default class GameBet {
    public id  :string;
    public stack : number;
    public betType : BetType;
    public state : BetState;
    public odds  :number;
    public contestLiveTime  :string;
    

    constructor(id:string , stack : number , betType : BetType , state:BetState , odds:number, contestLiveTime:string ) {

        this.id = id;
        this.stack = stack;
        this.betType = betType;
        this.state = state;
        this.odds = odds;
        this.contestLiveTime = contestLiveTime;
    }
}